import React, { ReactNode } from 'react';

interface ServiceModalProps {
  id: number;
  title: string;
  longDesc: string | ReactNode;
}

const ServiceModal: React.FC<ServiceModalProps> = ({ id, title, longDesc }) => {
  return (
    <div
      className="modal fade"
      id={`serviceModal${id}`}
      tabIndex={-1}
      aria-labelledby={`serviceModalLabel${id}`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header bg-body-tertiary py-3 border-body">
            <h5
              className="modal-title fw-bold text-body-emphasis"
              id={`serviceModalLabel${id}`}
            >
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Chiudi"
            />
          </div>
          <div
            className="modal-body p-4 bg-body"
            style={{ maxHeight: '60vh', overflowY: 'auto' }}
          >
            {typeof longDesc === 'string' ? (
              <p className="mb-0 text-body">{longDesc}</p>
            ) : (
              longDesc
            )}

            <div className="modal-footer bg-body-tertiary py-3 border-body">
              <button
                type="button"
                className="btn btn-primary px-4"
                data-bs-dismiss="modal"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
